import React from "react";
import { Row } from "react-bootstrap";

export interface IErrorExclamation {
  errorMessage: string | React.ReactNode;
  avoidExclamation?: boolean;
  avoidBackground?: boolean;
  parentClass?: string;
  childClass?: string;
  ChildContent?:React.ReactNode
}

const ErrorExclamation = (props: IErrorExclamation) => {
  return (
    <div className={`${props.parentClass ? props.parentClass : "mt-2"}`}>
      <div
        className={`invalidMsg ${
          !props.avoidBackground && "bg_lightPinkTwo change-bg-pastal"
        }`}
      >
        <div
          className={` ${
            props.childClass ? props.childClass : ""
          } DMSansNormal_12_400 txt_bloodRed  d-flex align-items-center`}
        >
          {!props.avoidExclamation && (
            <div className="edel-icon-validation"></div>
          )}
          <div className="p-1">{props.errorMessage}{props?.ChildContent}</div>
        </div>
      </div>
    </div>
  );
};

export default ErrorExclamation;
